module.exports = __webpack_public_path__ + "pdf/short.1b34fd9.pdf";